import { PAGE_LIMIT } from 'constants/index';
import { SupplierTabType } from 'interfaces/TabTypes';
import { Scope, SuppliersPayload, SupplierStatus } from 'generated/graphql';

export type State = {
  page: number;
  scope: Scope;
  count: number;
  search: string;
  rowsPerPage: number;
  activeTab: SupplierTabType;
  data: SuppliersPayload['data'];
};

export const initialState: State = {
  page: 1,
  count: 0,
  data: [],
  search: '',
  scope: Scope.All,
  rowsPerPage: PAGE_LIMIT,
  activeTab: SupplierStatus.Active,
};

export enum ActionType {
  SET_PAGE = 'setPage',
  SET_SCOPE = 'setScope',
  SET_DATA = 'setData',
  SET_COUNT = 'setCount',
  SET_SEARCH = 'setSearch',
  SET_ACTIVE_TAB = 'setActiveTab',
  SET_ROWS_PER_PAGE = 'setRowsPerPage',
}

export type Action =
  | { type: ActionType.SET_PAGE; page: number }
  | { type: ActionType.SET_SCOPE; scope: Scope }
  | { type: ActionType.SET_COUNT; count: number }
  | { type: ActionType.SET_DATA; data: SuppliersPayload['data'] }
  | { type: ActionType.SET_SEARCH; search: string }
  | { type: ActionType.SET_ACTIVE_TAB; activeTab: SupplierTabType }
  | { type: ActionType.SET_ROWS_PER_PAGE; rowsPerPage: number };

export const supplierReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_PAGE:
      return {
        ...state,
        page: action.page,
      };

    case ActionType.SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.rowsPerPage,
      };

    case ActionType.SET_COUNT:
      return {
        ...state,
        count: action.count,
      };

    case ActionType.SET_DATA:
      return {
        ...state,
        data: action.data,
      };

    case ActionType.SET_SEARCH:
      return {
        ...state,
        search: action.search,
      };

    case ActionType.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.activeTab,
      };

    case ActionType.SET_SCOPE:
      return {
        ...state,
        scope: action.scope,
      };
  }
};
